import '@babel/polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import App from /* webpackPrefetch: true */ './App'
import router from './router'
import store from './store'
// import './components'
import './plugins'
import { vuei18n } from './plugins/VueI18n'
import './registerServiceWorker'
import './filters'

window.bootstrap = function () {
  Vue.use(Vuex)
  new Vue({
    i18n: vuei18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
